/* eslint-disable import/prefer-default-export */
import { INIT } from './types';

export const init = () => ({ type: INIT });
